import { useMemo, TimeHTMLAttributes } from 'react';

interface DateTimeProps extends Omit<TimeHTMLAttributes<HTMLTimeElement>, 'children' | 'dateTime'> {
  value?: string;
}

export const DateTime = ({ value, ...props }: DateTimeProps) => {
  const text = useMemo(() => {
    const parts = value ? value.split('T') : [];
    if (!parts.length) return null;

    return [parts[0] ? parts[0].split('-').reverse().join('.') : null, parts[1] ? parts[1].split(':').slice(0, 2).join(':') : null]
      .filter((item) => !!item)
      .join(' ');
  }, [value]);

  return (
    <time {...props} dateTime={value}>
      {text}
    </time>
  );
};
